var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClass,attrs:{"data-testid":_vm.dataTestId,"aria-hidden":"false","aria-label":"Carregando"}},[_c('div',{class:_vm.spinnerClass}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }